import { useState, useEffect } from 'react';
// Types
import { SelectChangeEvent } from '@mui/material';

export type UseSelectType = {
  actions: {
    resetValue: () => void;
    changeValue: (newValue: string) => void;
  };
  attributes: {
    value: string;
    onChange: (event: SelectChangeEvent<string>) => void;
  };
};

const useSelect = (initialValue: string = ''): UseSelectType => {
  const [value, setValue] = useState<string>(initialValue);

  const onChange = (event: SelectChangeEvent<string>) => {
    setValue(event.target.value as string);
  };

  const changeValue = (newValue: string) => {
    setValue(newValue);
  };

  const resetValue = () => {
    setValue(initialValue ?? '');
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return {
    actions: { resetValue, changeValue },
    attributes: { value, onChange },
  };
};

export default useSelect;
